// Studyo Today Backend
// Package studyo.today.classroom.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/classroom/v1/resources/sync_blocker.proto (package studyo.today.classroom.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/classroom/v1/resources/sync_blocker.proto.
 */
export const file_studyo_today_classroom_v1_resources_sync_blocker = /*@__PURE__*/
  fileDesc("CjZzdHVkeW8vdG9kYXkvY2xhc3Nyb29tL3YxL3Jlc291cmNlcy9zeW5jX2Jsb2NrZXIucHJvdG8SI3N0dWR5by50b2RheS5jbGFzc3Jvb20udjEucmVzb3VyY2VzKpsCCgtTeW5jQmxvY2tlchIcChhTWU5DX0JMT0NLRVJfVU5TUEVDSUZJRUQQABIfChtTWU5DX0JMT0NLRVJfSU5URVJOQUxfRVJST1IQARIpCiVTWU5DX0JMT0NLRVJfTk9fR09PR0xFX09GRkxJTkVfQUNDRVNTEAISLQopU1lOQ19CTE9DS0VSX01JU1NJTkdfR09PR0xFX0FDQ0VTU19TQ09QRVMQAxIqCiZTWU5DX0JMT0NLRVJfSU5TVUZGSUNJRU5UX0VOVElUTEVNRU5UUxAEEiQKIFNZTkNfQkxPQ0tFUl9OT19DTEFTU1JPT01fQUNDRVNTEAUSIQodU1lOQ19CTE9DS0VSX1VORVhQRUNURURfRVJST1IQBkIrqgIoU3R1ZHlvLlRvZGF5LkNsYXNzcm9vbS5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.classroom.v1.resources.SyncBlocker.
 */
export const SyncBlockerSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_classroom_v1_resources_sync_blocker, 0);

/**
 * Represents something that is preventing a successful sync with external services.
 *
 * @generated from enum studyo.today.classroom.v1.resources.SyncBlocker
 */
export const SyncBlocker = /*@__PURE__*/
  tsEnum(SyncBlockerSchema);

